{
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "delete": "Xóa",
    "edit": "Chỉnh sửa",
    "back": "Quay lại",
    "next": "Tiếp theo",
    "previous": "Trước đó",
    "search": "Tìm kiếm",
    "loading": "Đang tải...",
    "submit": "Gửi",
    "close": "Đóng",
    "yes": "Có",
    "no": "Không",
    "login": "Đăng nhập",
    "logout": "Đăng xuất",
    "register": "Đăng ký",
    "email": "Email",
    "password": "Mật khẩu",
    "phone": "Số điện thoại",
    "settings": "Cài đặt",
    "profile": "Hồ sơ",
    "dashboard": "Bảng điều khiển",
    "actions": "Hành động",
    "status": "Trạng thái",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày cập nhật",
    "cookie": {
        "banner": {
            "title": "Chúng tôi sử dụng cookie",
            "message": "Chúng tôi sử dụng cookie để cải thiện trải nghiệm của bạn và phân tích lưu lượng truy cập.",
            "accept": "Chấp nhận tất cả",
            "reject": "Chỉ cookie cần thiết",
            "manage": "Quản lý tùy chọn",
            "learnMore": "Tìm hiểu thêm"
        }
    }
}
